module.exports = __webpack_public_path__ + "static/media/home_hover.d9a8e0cd.svg";